/**
 * The "Converted N times" flag next to a converting search term row
 * (see convertingSearchTerm.ts). N is the search term's conversions over
 * every campaign and ad group. Renders nothing for a term that never
 * converted.
 */
import { EvidenceChip } from './EvidenceChip';
import {
  CONVERTED_TITLE,
  convertedCopy,
  isConvertingRec,
  recConversions,
} from './convertingSearchTerm';

export function ConvertedBadge({
  rec,
}: {
  rec: {
    metrics: { conversions: number };
    term_conversions?: number | null;
    term_converting?: boolean | null;
  };
}) {
  if (!isConvertingRec(rec)) return null;
  return (
    <EvidenceChip
      tone="warning"
      label={convertedCopy(recConversions(rec))}
      title={CONVERTED_TITLE}
    />
  );
}

export default ConvertedBadge;
